<template>
  <div v-if="loaded">
    <div class="flex-row justify-content-end" style="width: 240px; height: 30px; position: relative">

      <dd-button
        small
        outline
        :type="statusColor"
        style="width: 240px; font-size: 12px"
        @click="showDrawer = true"
      >
        <dd-icon slot="icon" :icon="statusIcon" size="lg" :class="statusColor"/>
        <div class="width-stretch flex-col align-items-center">
          {{statusDescription}}
        </div>
      </dd-button>

      <dd-drawer
        title="E-mail informatie"
        placement="right"
        :closable="true"
        :visible="showDrawer"
        @close="showDrawer = false"
        :width="450"
      >
        <div class="events" v-for="(events, type) in emailEvents">

          <div v-if="type === 'processed'">
            <div class="row">
              <img class="logo" src="/img/branding/dossierdata-icon-91x91.png" alt="DossierData"/>
              <h3>E-mail verzonden</h3>
            </div>
            <p class="description">Verzonden door DossierData</p>
            <p class="date">{{getLatestDate(events)}}</p>
          </div>

          <div v-if="type === 'delivered'">
            <div class="row">
              <img v-if="hasProvider(events)" :src="getProvider(events).logo" class="logo"
                   :alt="getProvider(events).name">
              <dd-icon v-if="!hasProvider(events)" icon="mdi mdi-server" class="icon"/>
              <h3>E-mail ontvangen</h3>
            </div>
            <p class="description">Ontvangen door
              <span v-if="hasProvider(events)">
                      <a-tooltip placement="top">
                          <template slot="title">
                              <span>{{ events.find(Boolean).hostname }}</span>
                          </template>
                          {{ getProvider(events).hostname }}
                      </a-tooltip>
                  </span>
              <span v-if="!hasProvider(events)">
                      {{ events.find(Boolean).hostname }}
                  </span>
            </p>
            <p class="date">{{getLatestDate(events)}}</p>
          </div>

          <div v-if="type === 'bounce'">
            <div class="row">
              <dd-icon icon="mdi mdi-close-octagon" class="icon color-danger"/>
              <h3 class="color-danger">Kon niet worden bezorgd</h3>
            </div>
            <p class="description">Geweigerd door
              <span v-if="hasProvider(events)">
                <a-tooltip placement="top">
                    <template slot="title">
                        <span>{{ events.find(Boolean).hostname }}</span>
                    </template>
                    {{ getProvider(events).hostname }}
                </a-tooltip>
              </span>
              <span v-if="!hasProvider(events)">
                ontvanger
              </span>
            </p>
            <p class="date">{{getLatestDate(events)}}</p>
          </div>

          <div v-if="type === 'spamreport'">
            <div class="row">
              <dd-icon icon="mdi mdi-bug" class="icon color-danger"/>
              <h3 class="color-danger">Gemarkeerd als spam</h3>
            </div>
            <p class="date">{{getLatestDate(events)}}</p>
          </div>

          <div v-if="type === 'dropped'">
            <div class="row">
              <dd-icon icon="mdi mdi-email-search" class="icon color-danger"/>
              <h3 class="color-danger">Onbekend e-mailadres</h3>
            </div>
            <p class="date">{{getLatestDate(events)}}</p>
          </div>

          <div v-if="type === 'open'">
            <div class="row">
              <dd-icon icon="mdi mdi-account" class="icon"/>
              <h3>E-mail geopend</h3>
            </div>
            <p class="description">{{events.length}} keer geopend door {{ firstSelectedEmail.to }}</p>
            <p class="date">{{getLatestDate(events)}}</p>
          </div>

          <div v-if="type === 'click'">
            <div class="row">
              <dd-icon icon="mdi mdi-gesture-tap" class="icon"/>
              <h3>E-mail interactie</h3>
            </div>
            <p class="description">{{events.length}} keer een interactie met de e-mail</p>
            <p class="date">{{getLatestDate(events)}}</p>
          </div>

        </div>
      </dd-drawer>
    </div>
  </div>
</template>



<script>
import EmailEventApi from '~/api/emailEvent';
import {mapGetters} from "vuex";

export default {
  name: "EmailEventsComponent.vue",
  data(){
    return {
      loaded: false,
      showDrawer: false,
      latestStatus: '',
      emailEvents: {}
    }
  },
  mounted(){
    this.loadEmailEvents();
  },
  methods: {
    isSuccessful (event) {
      return event.type === 'processed'
          || event.type === 'delivered'
          || event.type === 'open'
    },
    hasProvider (events) {
      return this.getProvider(events) !== null
    },
    getProvider (events) {
      let eventWithHostname = events.find(event => event.hostname !== null)

      if (eventWithHostname) {

        let hostname = eventWithHostname.hostname

        if (hostname.match(/.*outlook\.com/)) {
          return {
            name: 'Outlook',
            hostname: 'outlook.com',
            logo: '/img/logo/outlook.png',
          }
        } else if (hostname.match(/.*google\.com/) || hostname.match(/.*gmail\.com/)) {
          return {
            name: 'Gmail',
            hostname: 'google.com',
            logo: '/img/logo/google.png',
          }
        } else if (hostname.match(/.*exchangelabs\.com/)) {
          return {
            name: 'Microsoft Exchange',
            hostname: 'exchangelabs.com',
            logo: '/img/logo/exchange.png',
          }
        } else if (hostname.match(/.*dazure\.nl/)) {
          return {
            name: 'Dazure',
            hostname: 'mail.dazure.nl',
            logo: '/img/logo/dazure.png',
          }
        } else if (hostname.match(/.*taf\.local/)) {
          return {
            name: 'TAF',
            hostname: 'taf.nl',
            logo: '/img/logo/taf.png',
          }
        }
      }
      return null
    },
    getLatestDate(events){
      return events[events.length -1].created_at.replace(/\//g, '-');
    },
    loadEmailEvents(){
      if (this.firstSelectedEmail.sent){

        EmailEventApi.getByEmailIdGroupedByType(this.firstSelectedEmail.id).then(({data}) => {
          this.emailEvents = data;
          const statusses = ['open', 'delivered', 'bounce', 'dropped', 'processed']
          for(let i = 0; i < statusses.length; i++){
            if (this.emailEvents[statusses[i]]){
              this.latestStatus = statusses[i];
              break;
            }
          }
          this.loaded = !Array.isArray(data);
        });

      } else {

        this.loaded = false;

      }
    }
  },
  computed: {
    ...mapGetters("email", [
      "firstSelectedEmail"
    ]),
    statusIcon(){
      switch (this.latestStatus){
        case 'open':
          return 'mdi mdi-email-open-outline';

        case 'delivered':
          return 'mdi mdi-email-arrow-left-outline';

        case 'processed':
          return 'mdi mdi-email-arrow-right-outline';

        case 'bounce':
          return 'mdi mdi-close-octagon-outline';

        case 'dropped':
          return 'mdi mdi-email-alert-outline';

        default:
          return 'mdi mdi-email';
      }
    },
    statusDescription(){
      switch (this.latestStatus){
        case 'open':
          return 'E-mail is geopend';

        case 'delivered':
          return 'E-mail is ontvangen';

        case 'processed':
          return 'E-mail is verzonden';

        case 'bounce':
          return 'E-mail kon niet worden bezorgd';

        case 'dropped':
          return 'Onbekend e-mail adres';

        default:
          return '';
      }
    },
    statusColor(){
      switch (this.latestStatus){
        case 'open':
        case 'delivered':
        case 'processed':
          return 'primary';

        case 'bounce':
        case 'dropped':
        default:
          return 'danger';
      }
    }
  },
  watch:{
    firstSelectedEmail(){
      this.loadEmailEvents();
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/_default.scss";
  .events{
    margin-bottom: $spacing-md;

    &:last-child{
      margin-bottom: 80px; // margin for crisp icon
    }

    &>div {
      position: relative;
      min-height: 115px;
      border-bottom: solid #ccc 1px;
      padding-bottom: $spacing-md;

      .row{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: $spacing-md;

        h3{
          margin: 0;
        }
      }

      .logo, .icon, .icon>svg, .fallback-icon{
        width: $spacing-xxl;
        height: $spacing-xxl;
        color: $brand-primary;
        fill: $brand-primary;
        align-self: start !important;
      }

      .description{
        margin-left: calc(#{$spacing-xxl} + #{$spacing-md});
        margin-top: $spacing-xs;
      }

      .date{
        position: absolute;
        right: 0;
        bottom: 0;
        text-align: right;
      }
    }
  }
</style>